module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-setting-panel"
  }, [_c('div', {
    staticClass: "nav flex-column nav-pills nav-fill drug-setting-nav"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'DrugDBSettings'
      }
    }
  }, [_vm._v("藥物資料庫")]), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'DrugGroupSettings'
      }
    }
  }, [_vm._v("藥物群組")]), (_vm.serverPrivilege.schedule) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ComboSettings'
      }
    }
  }, [_vm._v("套藥設定")]) : _vm._e()], 1), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6ae5ddc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/DrugSettings.vue
// module id = 1539
// module chunks = 1